import React, { useState, useEffect } from 'react';

const TestimonialsCarousel = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [expandedCards, setExpandedCards] = useState({});

  const testimonials = [
    {
      id: 1,
      name: "Matthew D.",
      role: "Content Creator",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/digital-ads-software-avatar-4.webp",
      text: "FrenzyPost lets me repurpose content across all channels in one go without needing to visit all social platforms for each post!",
      date: "Mar 14, 2025",
      rating: null
    },
    {
      id: 2,
      name: "Bernardo T.",
      role: "Content Creator",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/Solar-Panel-Testimonials-Image-1.webp",
      text: "It lets me manage all my social posts from a single dashboard saving me hours weekly.",
      date: "Mar 3, 2025",
      rating: null
    },
    {
      id: 3,
      name: "Ram K.",
      role: "Content Creator",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/AI-Voice-Generator-Testimonials-Image-7.webp",
      text: "I've tried multiple management tools but this has the best and most easy to use dashboard with full control.",
      date: "Jun 10, 2025",
      rating: 5
    },
    {
      id: 4,
      name: "Olivia A.",
      role: "Influencer",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/digital-ads-software-avatar-3.webp",
      text: "As an influencer jumping around multiple platforms, is so time saving. The AI-driven post ideas spark fresh content, and the unified dashboard lets me queue up Instagram, TikTok, and Twitter and Youtube at once. Scheduling in advance means I never miss to post on specific times to hit the best interaction.",
      date: "Jun 4, 2025",
      rating: null,
      showMore: true
    },
    {
      id: 5,
      name: "Ram K.",
      role: "Content Creator",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/AI-Voice-Generator-Testimonials-Image-7.webp",
      text: "Nice and easy to understand UI, freeing up a bunch of hours by the week.",
      date: "Apr 16, 2025",
      rating: 5
    },
    {
      id: 6,
      name: "Maria M.",
      role: "Social Media Manager",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/digital-ads-software-avatar-6.webp",
      text: "Managing multiple brand's entire social presence used to feel like spinning plates—until I found FrenzyPost. Now I draft captions with AI, schedule posts across all channels in seconds, and preview the exact look of each feed. I've cut my weekly posting time in half and can focus on strategic storytelling while managing more clients.",
      date: "May 20, 2025",
      rating: 5,
      showMore: true
    },
    {
      id: 7,
      name: "Ben S.",
      role: "Solo Entrepreneur",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/digital-ads-software-avatar-2.webp",
      text: "Running my own business means wearing a dozen hats—marketing included. FrenzyPost's all-in-one dashboard lets me plan, schedule social campaigns in one place, and its AI suggestions improved my content. It's the timesaving boost every solo founder needs.",
      date: "Apr 28, 2025",
      rating: 5,
      showMore: true
    },
    {
      id: 8,
      name: "Amily M.",
      role: "Branding Specialist",
      profilePic: "https://www.frenzypost.com/wp-content/uploads/2025/06/digital-ads-software-avatar-5.webp",
      text: "Crafting a unified brand voice across social channels can be a challenge—FrenzyPost makes it effortless.",
      date: "May 15, 2025",
      rating: 5
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setScrollPosition((prevPosition) => {
        const newPosition = prevPosition + 1;
        const maxScroll = testimonials.length * 400; // Approximate width of all cards
        return newPosition >= maxScroll ? 0 : newPosition;
      });
    }, 50); // Smooth scrolling speed

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const toggleCardExpansion = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const renderStars = (rating) => {
    if (!rating) return null;
    return (
      <div className="flex items-center mb-2">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full overflow-hidden bg-gray-50 py-8">
      <div className="w-full px-4">
        <h3 className="text-2xl sm:text-3xl font-bold text-center mb-8 text-gray-800">
          What Our Users Say 💬
        </h3>
        
        <div className="relative overflow-hidden">
          <div 
            className="flex transition-transform duration-1000 ease-linear"
            style={{ transform: `translateX(-${scrollPosition}px)` }}
          >
            {/* Duplicate testimonials for seamless loop */}
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div key={`${testimonial.id}-${index}`} className="flex-shrink-0 w-80 mx-4">
                <div className={`bg-white rounded-lg shadow-lg border border-gray-200 p-6 relative flex flex-col ${expandedCards[testimonial.id] ? 'h-auto' : 'h-60'}`}>
                  {/* Profile section */}
                  <div className="flex items-center mb-4">
                    <img
                      src={testimonial.profilePic}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover mr-3"
                    />
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900">{testimonial.name}</div>
                      <div className="flex items-center justify-between">
                        <div className="text-sm text-gray-600">{testimonial.role}</div>
                        <div className="text-sm text-gray-500">{testimonial.date}</div>
                      </div>
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>

                  {/* Testimonial text */}
                  <div className={`text-gray-700 mb-4 flex-grow min-h-[4.5rem] ${!expandedCards[testimonial.id] && testimonial.showMore ? 'line-clamp-3' : ''}`}>
                    {testimonial.text}
                  </div>

                  {/* Show more button */}
                  {testimonial.showMore && (
                    <button 
                      onClick={() => toggleCardExpansion(testimonial.id)}
                      className="text-blue-600 hover:text-blue-800 font-medium text-sm"
                    >
                      {expandedCards[testimonial.id] ? 'Show less' : 'Show more'}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsCarousel; 